import React, { useState, useEffect,useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha"
import { Formik, Field, Form as FormikForm } from "formik";
import { Checkbox, Input, Icon, Divider,Form } from "semantic-ui-react";
import {FormikInputComponent} from "../../../utilities/formUtils";
import {gettingOTPCallMain} from "../data/action";


const Signup_Step_Two = (props) => {
    const dispatch = useDispatch();
    const onchangehandle = (e,data) =>{
        // console.log(e.target,"===>>",data)
        props.setPwrdErrorClass("");
        props.setcustomPwrdErrorMsg("");
        props.setcurVerCodeerrorClass("");
        props.setcustomVerCodeErrorMsg("");
        if(e.target.name=="validationpw"){
            props.setpwtolog(data.value)
        }
        if(e.target.name=="validationotp"){
            props.setverificationOtpval(data.value)
        }
    }
    const loginwithotpChkbxChange = (e,data)=>{
        props.setloginWithOtpChkVal(data.checked)
    }
    const resendOtp = (value) => {
        dispatch(gettingOTPCallMain({
            data:props.values.email_id,
            curState:props.curState
        }));
    }
    return(
        <div style={{display :props.displayparam}}>
            <div className="sign-up-head">
                <h3 className="signuptxt">Hi <div className="ellipses userloginStyle" title={(props.emailid == "") ? "Dear" : props.emailid}>{(props.emailid == "") ? "Dear" : props.emailid}</div>, Welcome Back!</h3>
            </div>
            <div className="sign-up-form-info">
                {
                    props.loginWithOtpChkVal ? "" :
                    <>
                <Form.Group widths={2}>
                    <div className="mb-3">
                        <label for="Inputemail" className="sign-up-field-name form-label">Enter your Password</label>
                        <Field
                            id="password"
                            name="validationpw"
                            noLabel="y"
                            component={FormikInputComponent}
                            icontoShow = 'lock'
                            iconPosition='left'
                            placeholder = "Enter your password"
                            style={{marginTop:"11px"}}
                            inputtype="password"
                            className={props.curPwrderrorClass}
                            myChangeFunction = {onchangehandle}
                            iserror={props.curPwrderrorClass != "" ? true : false}
                            customErrorMsg = {props.customPwrdErrorMsg}
                            userProps={{value:props.pwtolog}}
                        />
                    </div>
                </Form.Group>
                <Divider horizontal className="dividerClassPw">Or</Divider>
                </>
                }                        
                        <Checkbox 
                            label='Login with OTP' 
                            className="logWithOTPcss"
                            checked={props.loginWithOtpChkVal}
                            onChange={loginwithotpChkbxChange}
                        />
                        {
                            props.loginWithOtpChkVal ? 
                            <Form.Group widths={2}>
                                <div className="mb-3">
                                <label for="" className="sign-up-field-name form-label marginTopSecondRow">Email Verification Code</label>
                                <Field
                                    id="verification_code"
                                    name="validationotp"
                                    noLabel="y"
                                    component={FormikInputComponent}
                                    icontoShow = 'key'
                                    iconPosition='left'
                                    placeholder = "Enter your number"
                                    // style={{marginTop:"11px"}}
                                    className={props.curVerCodeerrorClass}
                                    myChangeFunction = {onchangehandle}
                                    iserror={props.curVerCodeerrorClass != "" ? true : false}
                                    customErrorMsg = {props.customVerCodeErrorMsg}
                                    userProps={{value:props.verificationOtpval}}
                                />
                                {/* <Input icon='key' iconPosition='left' placeholder='Enter the OTP' size="large" className="signupinputs"/> */}
                                <div className="otp-info">OTP has been sent to {props.values.email_id}</div>
                                <div className="otp-info alignCenter beforeButtonText">Didn't receive the OTP? <a className="cursorPointer" onClick={resendOtp}>Resend</a></div>
                            </div>
                            </Form.Group>
                            : ""
                        }
            </div>
        </div>
    )
}
export default Signup_Step_Two;